import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import styled from 'styled-components'
import SearchInput from '../../containers/ESSearch/SearchInput'
import ESSearch from '../../containers/ESSearch'

const StyledModal = styled(Modal)`
  .custom-modal {
    max-height: 176px;
    width: var(--modal-width);
    margin: 118px auto;
    background-color: var(--clr-bg);
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 30px;
    border-radius: var(--border-radius);

    .modal-body {
      position: initial;
      padding: 0;
      width: -webkit-fill-available;
    }

    .modal-content {
      background-color: var(--clr-bg);
      box-shadow: none;
      border: none;
      margin: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: static;
      min-width: 100%;
    }
  }

  .modal-header {
      padding: 0;
      border-bottom: none;
  }

  .close {
      position: absolute;
      right: var(--xl);
      top: var(--sm);
  }

  @media (max-width: 768px) {
    .custom-modal {
      margin: var(--header-height) auto;
      padding: 0;
      max-height: var(--search-input-height);
    }

    .close {
        right: var(--3xl);
        top: var(--lg);
    }
  }
`

const SearchModal = ({ onHide, initialQuery }) => {
  const [query, setQuery] = useState(initialQuery)

  return (
    <StyledModal
      key={1}
      show={true}
      dialogClassName="custom-modal"
      onHide={onHide}
    >
      <Modal.Header closeButton />
      <Modal.Body>
        <SearchInput query={query} handleChange={setQuery} isInModal={true} />
        <ESSearch hideSearch={onHide} query={query} />
      </Modal.Body>
    </StyledModal>
  )
}

SearchModal.propTypes = {
  onHide: PropTypes.func.isRequired,
  initialQuery: PropTypes.string
}

export default SearchModal



// WEBPACK FOOTER //
// ./src/components/ESSearch/SearchModal.js